import createReducer from 'common/redux/utils/createReducer';
import {
  REQUEST_TIP,
  RECEIVE_TIP,
  TIP_RECEIVE_FAILED,
  SAVING_TIP,
  TIP_SAVE_FAILED,
} from 'tip/actions/tip';

const initialState = {
  isFetching: false,
  didInvalidate: false,
};

const tip = createReducer(initialState, {
  [REQUEST_TIP](state, action) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_TIP](state, { tip }) {
    return {
      ...state,
      isFetching: false,
      tip,
    };
  },
  [TIP_RECEIVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      receiveError: error,
    };
  },
  [SAVING_TIP](state, { tip }) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [TIP_SAVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      saveError: error,
    };
  },
});

export default tip;



// WEBPACK FOOTER //
// ./src/modules/tip/reducers/tip.js